import * as React from 'react';
import { Grid } from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import Fade from '@material-ui/core/Fade';
import MenuItem from "@material-ui/core/MenuItem";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { Sucursal } from "../../entities/catalogos/Sucursal";
import { traducirLabel, traducirMessage } from '../../blocks/traductor';

interface OwnProps {
    value: Sucursal
    esOrigen: boolean
    onChange: (sucursal: Sucursal | undefined) => void
}

interface StateProps {
    sucursales: Sucursal[]
}

type Props = OwnProps & StateProps;

const SucursalComponente = ({ value, esOrigen, sucursales, onChange }: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSucursal = (sucursalId: number) => {
        if (sucursalId) {
            const sucursal = sucursales.find(s => s.id === sucursalId);
            onChange(sucursal);
        }

        setAnchorEl(null);
    };

    const handleClose = (sucursalId: number) => {
        setAnchorEl(null);
    };

    return (<>
        <Box display="flex" mt={4} mb={1}>
            <Box className="title-2" mr={4}>
                {esOrigen ? traducirMessage(222) : traducirMessage(221)}
            </Box>
            <Box>
                <small onClick={handleClick} className="pointer green-label">
                    <b>
                        {/* Buscar otras opciones */
                            traducirLabel(22)}
                    </b>
                </small>
                <Menu
                    id="fade-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    TransitionComponent={Fade}
                >
                    {sucursales.map(s => {
                        return (<MenuItem key={s.id} onClick={() => handleSucursal(s.id)}>
                            {s.nombre}
                        </MenuItem>)
                    })}
                </Menu>
            </Box>
        </Box>

        {value &&
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={5}>
                    <Box className="card medium-height selected" display="flex" flexDirection="column"
                        justifyContent="center" style={{ padding: "10px 20px" }}>
                        <Box className="title-3 green-label text-center">
                            <b>{value?.nombre}</b>
                        </Box>
                        <Box className="title-4 text-center" my={1}>
                            <b>{value.direccion}</b>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    sucursales: state.sucursales
});

export default connect(mapStateToProps)(SucursalComponente);
